(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var overlay = document.getElementById('cart-drawer-overlay');
    var cartLink = document.getElementById('cart-icon-link');
    if (!overlay || !cartLink) return;

    var backdrop = overlay.querySelector('.cart-drawer-overlay__backdrop');
    var closeBtn = overlay.querySelector('.cart-drawer__close');
    var drawerForm = document.getElementById('cart-drawer-form');

    function openDrawer() {
      overlay.classList.add('cart-drawer-overlay--open');
      overlay.removeAttribute('aria-hidden');
      document.body.classList.add('cart-drawer-lock');
      var panel = document.getElementById('cart-drawer');
      if (panel) panel.focus();
    }

    function closeDrawer() {
      overlay.classList.remove('cart-drawer-overlay--open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-lock');
      cartLink.focus();
    }

    cartLink.addEventListener('click', function(e) {
      if (window.innerWidth <= 749) return;
      e.preventDefault();
      openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('cart-drawer-overlay--open')) {
        closeDrawer();
      }
    });

    if (drawerForm) {
      drawerForm.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        e.preventDefault();
        var stepper = btn.closest('.cart-drawer-item__stepper');
        var input = stepper.querySelector('.cart-drawer-item__qty');
        var current = parseInt(input.value, 10) || 0;
        if (btn.dataset.action === 'increase') {
          input.value = current + 1;
        } else if (btn.dataset.action === 'decrease') {
          input.value = Math.max(0, current - 1);
        }
        drawerForm.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('cart-form');
    if (!form) return;

    form.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;

      e.preventDefault();
      var stepper = btn.closest('.cart-item__stepper');
      var input = stepper.querySelector('.cart-item__qty');
      var current = parseInt(input.value, 10) || 0;

      if (btn.dataset.action === 'increase') {
        input.value = current + 1;
      } else if (btn.dataset.action === 'decrease') {
        input.value = Math.max(0, current - 1);
      }

      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  (() => {
    const items = document.querySelectorAll('.faq-item');
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach(other => {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const hasHero = !!document.querySelector('.hero');

    const updateHeader = () => {
      const threshold = hasHero ? window.innerHeight * 0.8 : -1;
      header.classList.toggle('header--solid', window.scrollY > threshold);
    };

    document.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const mainImg = document.getElementById('product-main-image');
    if (!mainImg) return;

    const thumbs = Array.from(document.querySelectorAll('.product__thumbnail'));
    if (thumbs.length === 0) return;

    let currentIndex = 0;

    function goToImage(index) {
      const thumb = thumbs[index];
      const fullSrc = thumb.dataset.fullSrc;
      const alt = thumb.dataset.alt;

      mainImg.addEventListener('transitionend', function onFade() {
        mainImg.removeEventListener('transitionend', onFade);
        mainImg.srcset = '';
        mainImg.src = fullSrc;
        mainImg.alt = alt;
        requestAnimationFrame(() => { mainImg.style.opacity = '1'; });
      }, { once: true });

      mainImg.style.opacity = '0';

      thumbs.forEach(t => {
        t.classList.remove('product__thumbnail--active');
        t.removeAttribute('aria-current');
      });
      thumb.classList.add('product__thumbnail--active');
      thumb.setAttribute('aria-current', 'true');
      currentIndex = index;
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToImage(i));
    });

    const prevBtn = document.querySelector('.product__gallery-arrow--prev');
    const nextBtn = document.querySelector('.product__gallery-arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goToImage((currentIndex - 1 + thumbs.length) % thumbs.length);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goToImage((currentIndex + 1) % thumbs.length);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
